export default "__VITE_ASSET__DeSznmgR__"